const replaceString = {

  // all -----------------------------------------------------------------------

  // it's easier and aster to count when every sentence ends as period
  everySentenceEndIsPeriod: (text) => {
    return text.replace(/[\.!\?]+/g,".");
  },

  // includes all accented letters
  onlyLettersAll: (text) => {
    return text.replace(/[^A-Za-z\u00c0-\u00d6\u00d8-\u00f6\u00f8-\u02af\u1d00-\u1d25\u1d62-\u1d65\u1d6b-\u1d77\u1d79-\u1d9a\u1e00-\u1eff\u2090-\u2094\u2184-\u2184\u2488-\u2490\u271d-\u271d\u2c60-\u2c7c\u2c7e-\u2c7f\ua722-\ua76f\ua771-\ua787\ua78b-\ua78c\ua7fb-\ua7ff\ufb00-\ufb06]+/g,"");
  },

  // Replace multiple spaces with single
  onlySingleSpace: (text) => {
    return text.replace(/\s{2,}/g, ' ');
  },

  // czech ---------------------------------------------------------------------
  // remove uses when number is in adjective form, e.g. 11. listopad
  // this prevents sentence "Je 11. listopad." to be counted as two sentences
  removeNumberAdjCzech: (text) => {
    return text.replace(/[0-9]\./g,"NUMBERDOT");
  },

  onlyLettersCzech: (text) => {
    return text.replace(/[^a-zA-ZáčďéěíňóřšťůúýžÁČĎÉĚÍŇÓŘŠŤŮÚÝŽ\.]/g, " ");
  },

  abbrCzech: (text) => {
    return text.replace(/dr\.|\sdr\.|\sDr\.|\smudr\.|\sMudr\.|\sbc\.|\sBc\./gi,"ABBRV");
  },

  monthsCzech: (text) => {
    return text.replace(/\.\sledna|\.\súnora|\.\sbřezna|\.\sdubna|\.\skvětna|\.\sčervna|\.\sčervence|\.\ssrpna|\.\száří|\.\sříjna|\.\slistopadu|\.\sprosince/gi,"DATE");
  },

  // english -------------------------------------------------------------------

  // remove uses when number either side e.g. 37.2 degrees
  removeDecimalNumbersEnglish: (text) => {
    return text.replace(/[0-9]\.[0-9]/g,"DECIM");
  },

  onlyLettersEnglish: (text) => {
    return text.replace(/[^A-Za-z\.]/g, " ");
  },

  abbrEnglish: (text) => {
    return text.replace(/\se\.g\.|\si\.e\.|\smr\.|\smrs\.|\sdr\.|\sms\.|\setc\.|\shwy\.|\srd\.|\sst\.|\spde\.|\scol\.|\sphd\.|\sbsc\.|\sc\.|\sca\.|\sb\.c\.|\sa\.d\.|\sb\.c\.e\.|\sb\.a\.|\scapt\.|\scent\.|\scorp\.|\scomdr\.|\scal\.|\sgal\.|\sdist\.|\sest\.|\set al\.|\sed\.|\sdiv\.|\sdec\.|\sjan\.|\sfeb\.|\smar\.|\sapr\.|\sjun\.|\sjul\.|\saug\.|\ssept\.|\soct\.|\snov\.|\sgov\.|\slat\.|\sm\.d\.|\smg\.|\smt\spl\.|\spop\.|\srev\.|\sr\.n\.|\svol\.|\ssr\.|\ssgt\.|\suniv\.|\svs\.|\swt\./gi,"ABBRV");
  }
}

export { replaceString };